import * as firebase from 'firebase'
import Vue from 'vue'
import {tidyText} from "../helpers.js"
import {tidyObj} from "../helpers.js"
import { Store } from 'vuex';
//import WreckData from '../../data/WrecksData.json'
//import DocumentData from '../../data/DocumentsData.json'

export default {
  state: {
    loading:false,
    loadingText:false,
    loadLocal:true,
    text:{},
    collection:{}
  },
  mutations: {
    loading(state,payload){
        state.loading=payload
    },
    loadingText(state,payload){
        state.loadingText=payload
    },
    setText(state, payload) {
      if(typeof payload.text =="string"){
        Vue.set(state.text,payload.collection,payload)
      }else{
        Vue.set(state.text,payload.collection,payload.text)
      }
    },
    
    addField(state,payload){ 
      Vue.set(state.text[payload.collection][payload.doc], payload.field, payload.content)
    }, 
    addDocument(state,payload){
      if(state.text[payload.collection]){
        Vue.set(state.text[payload.collection],payload.doc,payload.content)
      }else{
        Vue.set(state.text,payload.collection,[])
        Vue.set(state.text[payload.collection],payload.doc,payload.content)
      }
    },
    removeDocument(state,payload){
      Vue.delete(state.text[payload.collection], payload.doc);
    },
    removeField(state,payload){
      Vue.delete(state.text[payload.collection][payload.doc], payload.field);
    }
  },
  actions: {
    removeDocument({commit},payload){
      firebase.firestore().collection(payload.collection).doc(payload.doc).delete().then(function() {
        console.log("Document successfully deleted!");
        commit('removeDocument',payload)
    }).catch(function(error) {
        console.error("Error removing document: ", error);
    });
    },
    removeField({commit},payload){
      var updates={}
      updates[payload.field]=firebase.firestore.FieldValue.delete()
      
    
      firebase.firestore().collection(payload.collection).doc(payload.doc).update(updates).then(function() {
        console.log("Field successfully deleted!");
        commit('removeField',payload)
    }).catch(function(error) {
        console.error("Error removing document: ", error);
    });
    },
    addField({commit},payload){
      var updates={}
      updates[payload.field]=payload.content
      firebase.firestore().collection(payload.collection).doc(payload.doc).update(updates)
      .then(function() {
        console.log("Document successfully written!");
        commit('addField',payload)
        commit('loadingText',false)
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
        commit('loadingText',false)
      });
    },
    saveText({commit},payload){
        var content = firebase.firestore().collection(payload.collection)
        var field=payload.field || 'body'
        var updates={}
        updates[field]=payload.content
        content.get().then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
             content.doc(payload.doc).update(
              updates
              )
              .then(function() {
                console.log("Document successfully updated!");
               
              })
              .catch(function(error) {
                // The document probably doesn't exist.
                commit('loading', false)
                console.error("Error updating document: ", error);
              });
          });
        });
    },
    addDocument({commit},payload){
      commit('loadingText',true)
      firebase.firestore().collection(payload.collection).doc(payload.doc).set(
        payload.content
      )
      .then(function() {
        console.log("Document successfully written!");
        commit('addDocument',payload)
        commit('loadingText',false)
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
        commit('loadingText',false)
      });
    },
    async retreiveText({commit,getters},payload){
      if(getters.getTextElement({collection:payload.type,doc:payload.element})){
        return getters.getLocation(payload)
      }
     commit('loadingText',true)
    let data
    var db = firebase.firestore();
    var docRef =  db.collection(payload.type).doc(payload.element)
    await docRef.get().then(function(doc) {
  
      //data=doc.data().text
      data=doc.data()
      data=tidyObj(data)
      if(data.text){
        data.text=tidyText(data.text)
      }
      
   
      commit("addDocument",{collection:payload.type,doc:payload.element,content:data})
      
        return data.text

    }).catch(function(error) {
        console.log("Error getting document:", error);
        commit('loadingText',false)
      });
    },
    
    loadText({ commit,state },payload){
        commit('loadingText',true)
        var loadedText={}
        if(state.loadLocal && payload && false){
          console.log("LOAD LOCAL",payload)
          //let file = require('../../data/'+payload+'.json')
          const data = WreckData
          console.log("LOAD LOCAL",data)
          commit('setText',{collection:payload,text:data})
          commit('loadingText',false) 
          return
        }
        var db = firebase.firestore();
        var collRef = db.collection(payload)
        collRef.get().then(function(coll) {
            coll.forEach(function(doc) {
                loadedText[doc.id]=doc.data()
                console.log("AAAAAAAAA",doc.data())
            });
            commit('setText',{collection:payload,text:loadedText})
            console.log("LOADED",loadedText)
            commit('loadingText',false) 
        }).catch(function(error) {
            console.log("Error getting document:", error);
            commit('loadingText',false)
          });
    },
  },
  getters: {
    getTextElement:state => payload => {
   
      if(!state.text[payload.collection]){
       
        return null
      }
        return state.text[payload.collection][payload.doc] || null;
    },
    getLoadedText:state => payload => {
      console.log("Getting Text",payload,state.text[payload])
        return state.text[payload] || null;
    },
   
    loading(state) {
        return state.loading
    },
      loadingText(state) {
        return state.loadingText
    },
  }
}

